import { useIntl } from '@leagueplatform/locales';
import { paperlessModalContent } from 'data/paperless-confirmation-modal.data';

export const usePaperlessConfirmationModal = () => {
  const { formatMessage } = useIntl();

  const formattedContent = {
    title: formatMessage({ id: paperlessModalContent.title as never }),
    descriptions: paperlessModalContent.descriptions.map((desc) => ({
      ...desc,
      text: formatMessage({ id: desc.id as never }),
    })),
    cancelButton: formatMessage({
      id: paperlessModalContent.cancelButton as never,
    }),
    confirmButton: formatMessage({
      id: paperlessModalContent.confirmButton as never,
    }),
  };

  return {
    formattedContent,
  };
};
